import { Search, X } from "lucide-react";
import { AVATAR_COLORS } from "./constants";

export const GroupAvatar = ({ group, size = "md" }) => {
  const color    = AVATAR_COLORS[(group.id || 0) % AVATAR_COLORS.length];
  const initials = (group.name || "G").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  const sz       = size === "lg" ? "w-10 h-10 text-sm" : "w-12 h-12 text-sm";
  return (
    <div className={`${sz} rounded-full ${color} flex items-center justify-center text-white font-bold flex-shrink-0`}>
      {initials}
    </div>
  );
};

export const StatusDot = ({ status }) => {
  const cls = {
    sending:   "bg-blue-400 animate-pulse",
    completed: "bg-green-400",
    failed:    "bg-red-400",
    pending:   "bg-yellow-400",
  };
  return <span className={`w-2 h-2 rounded-full flex-shrink-0 ${cls[status] || cls.pending}`} />;
};

export const SearchInput = ({ value, onChange, placeholder }) => (
  <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-full px-3 py-1.5">
    <Search className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" />
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="flex-1 text-sm outline-none bg-transparent text-gray-700 placeholder-gray-400"
    />
    {value && (
      <button onClick={() => onChange("")}>
        <X className="w-3 h-3 text-gray-400" />
      </button>
    )}
  </div>
);

export const StatRow = ({ icon, barColor, bgColor, value, pctVal, label, onClick }) => (
  <div
    className={`flex items-center gap-2 rounded-lg px-1 -mx-1 ${onClick ? "cursor-pointer hover:bg-black/5 transition-colors" : ""}`}
    onClick={onClick}
  >
    <span className="flex-shrink-0">{icon}</span>
    <div className={`flex-1 ${bgColor} rounded-full h-1.5 overflow-hidden`}>
      <div className={`h-full ${barColor} rounded-full`} style={{ width: `${pctVal}%` }} />
    </div>
    <span className={`text-[11px] w-20 text-right whitespace-nowrap ${label}`}>{value}</span>
  </div>
);
